import { useState } from 'react'
import { LayerProps, RasterSource, RasterLayer } from 'react-map-gl'
import type { GeoJSONSourceRaw } from 'mapbox-gl'

interface UseLayerPropsState {
  sources: RasterSource[]
  layers: LayerProps[]
  charts: chart[]
  geojsonSources: GeoJSONSourceRaw[]
  geojsonLayers: LayerProps[]
  layerVisibility: boolean
  setLayerVisibility: (layerVisibility: boolean) => void
}

interface parts {
  id: string
  name: string
  layerConfig: RasterSource
}

interface chart {
  name: string
  parts: parts[]
}

const configureLayer = function (id: string, config: RasterSource) {
  const layerConfig = {
    id: id,
    type: config.type,
    source: id,
    minzoom: config.minzoom,
    maxzoom: config.maxzoom
  }
  return layerConfig
}

const chartSets = [
  {
    Identifier: 'ID20',
    Name: 'ID20',
    productName: 'ID20',
    description: 'Imray English Channel',
    Coordinates:
      '[[[2.809497575859657,51.383331941416095],[2.809497575859657,51.383331941416095]]]', // '[[[2.809497575859657,51.383331941416095],[2.383346104038491,51.383331941416095],[2.383346104038491,51.39166670341553],[2.1833458217840165,51.39166670341553],[2.1833458217840165,52.08499856372103],[0.3499970061929972,52.08499856372103],[0.3499970061929972,51.31049971936719],[1.2266713575376251,51.31049971936719],[1.2266713575376251,51.179677360468524],[0.49854653885401157,51.179677360468524],[0.49854653885401157,51.20044948229612],[-1.184860092207302,51.20044948229612],[-1.184860092207302,51.16666501375983],[-2.533333948847055,51.16666501375983],[-2.533333948847055,50.916665389168564],[-5.051635375191993,50.916665389168564],[-5.051635375191993,50.604330654124105],[-5.249972212159787,50.604330654124105],[-5.249972212159787,50.58254786003407],[-6.583320322113615,50.58254786003407],[-6.583320322113615,49.359993162436226],[-6.051984949432546,49.359993162436226],[-6.051984949432546,48.38333634039439],[-5.086915889199015,48.38333634039439],[-5.086915889199015,48.37145228868925],[-5.149546538517065,48.347791558529636],[-5.149546538517065,48.28029624856261],[-4.964710687721701,48.28029624856261],[-4.964710687721701,48.148128645167255],[-5.078405238890309,48.148128645167255],[-5.078405238890309,48.06926144346451],[-5.2681540560010856,48.06926144346451],[-5.2681540560010856,48.012999649218],[-4.147146671248469,48.012999649218],[-4.147146671248469,48.38333634039439],[-0.8333315496846192,48.38333634039439],[-0.8333315496846192,49.249998879158774],[-0.5568514689733616,49.249998879158774],[-0.5568514689733616,49.178958531053965],[-0.23333070292112706,49.178958531053965],[-0.23333070292112706,49.11666619539278],[1.7666721196238913,49.11666619539278],[1.7666721196238913,49.249998879158774],[1.8833453984013664,49.249998879158774],[1.8833453984013664,50.68331604014469],[1.9166143041535966,50.68331604014469],[1.9166143041535966,50.71683498838852],[2.809497575859657,50.71683498838852],[2.809497575859657,51.383331941416095]]]',
    files: [
      {
        id: 'ID20',
        name: 'ID20 English Channel'
      }
    ],
    OutlineColor: '#db5cb3'
  },
  {
    Identifier: 'ID100',
    Name: 'ID100',
    productName: 'ID100',
    description: 'Imray Eastern Caribbean',
    Coordinates:
      '[[[-68.1999998995,19.0000000063],[-71.9999998078,19.0000000063],[-71.9999998078,17.1789526736],[-71.9999998078,13.4123681338],[-71.9999998078,9.6499998757],[-63.1666667613,9.6499998757],[-63.1666667613,9.401766736],[-60.4328498664,9.401766736],[-60.4328498664,9.5096498385],[-60.4328498664,9.6499998757],[-59.1499286748,9.6499998757],[-58.0000000887,9.6499998757],[-58.0000000887,11.8086101566],[-58.0000000887,15.8201132937],[-58.0000000887,19.0000000063],[-58.4850246803,19.0000000063],[-60.2333330664,19.0000000063],[-60.2333330664,19.3333331001],[-68.1999998995,19.3333331001],[-68.1999998995,19.0000000063]]]',
    files: [
      {
        id: 'ID100',
        name: 'ID100 Eastern Caribbean North'
      }
    ],
    OutlineColor: '#db5cb3'
  },
  {
    Identifier: 'ID1',
    Name: 'ID1',
    productName: 'ID1',
    description: 'Imray Britain, Ireland and Northern Europe',
    Coordinates:
      '[[[-10.0835166667,49.2499997174],[-10.0835166667,48.99995],[-10.0835166537,48.99995],[-10.0835166537,47.6658804052],[-8.8316102447,47.6658804052],[-8.8316102447,44.4974074026],[-10.0835166537,44.4974074026],[-10.0835166537,43.5360089085],[-10.9999999587,43.5360089085],[-10.9999999587,40.8106666667],[-30.5895,40.8106666667],[-30.5895,39.7147396812],[-30.666212626,39.7147396812],[-30.666212626,39.8332683835],[-30.8330836545,39.8332683835],[-30.8330836545,39.9997456725],[-31.6716666562,39.9997456725],[-31.6716666562,39.166861202],[-30.6319433779,39.166861202],[-30.6319433779,38.2392214287],[-30.5895,38.2392214287],[-30.5895,25],[-2.9727666667,25],[-2.9727666667,40.8106666667],[-8.0039641152,40.8106666667],[-7.999215683,42.8665666588],[-3.9156669434,42.8665666588],[-3.9156669434,42.8541665183],[-2.9699046532,42.8542549869],[-2.9698991768,42.8665666588],[-0.8333836766,42.8665666588],[-0.8333836766,44.0796946331],[-0.7201668824,44.0797115901],[-0.7201668824,44.8466332997],[-0.5166667886,44.8466332997],[-0.5166667886,45.0496761083],[-0.6468971465,45.1666664847],[-0.6566665994,45.1666664847],[-0.6566665994,45.6333331348],[-0.7201668824,45.6333331348],[-0.7201668824,46.2011668379],[-0.8333836766,46.2011668379],[-0.8333836766,48.3733334278],[0.399725,48.3733334278],[0.399725,48.714756974],[1.9101168,48.714756974],[1.9101168,50.4382132767],[2.8095004956,50.4382094521],[2.809500413,50.7168333333],[3.4152593299,50.7168333333],[3.4152602205,51],[10.8333333333,51],[10.8333333333,55.0173174975],[8.6410018242,55.0233828794],[4.0423442514,55.84472628],[4.0482965666,56.276744486],[5.9351804589,56.8333333333],[3.4152799235,56.8333333333],[3.4152951117,60.7901711227],[-5.2166666667,60.7901711227],[-5.2166666862,60.0862196464],[-13.3897540874,60.0862196464],[-13.3897575691,49.2499995774],[-10.0835166667,49.2499997174]]]',
    files: [
      {
        id: 'ID1',
        name: 'ID1'
      }
    ],
    OutlineColor: '#db5cb3'
  }
]
// [
//   {
//     productName: 'ID20',
//     description: 'Imray English Channel',
//     files: [
//       {
//         id: 'ID20C',
//         name: 'ID20 English Channel East'
//       },
//       {
//         id: 'ID20B',
//         name: 'ID20 English Channel Central'
//       },
//       {
//         id: 'ID20A',
//         name: 'ID20 English Channel West'
//       }
//     ]
//   }
// ]

interface InitialState {
  [key: string]: boolean
}

const initialState: InitialState = {}

chartSets.forEach(chartSet => {
  chartSet.files.forEach(chart => {
    initialState[chart.id] = true
  })
})

export const useChartSets = (): UseLayerPropsState => {
  const [layerVisibility, setLayerVisibility] = useState(true)
  const chartSetImageBaseUrl = process.env.REACT_APP_CHART_SET_IMAGE_BASE_URL
  const rasterToken = localStorage.getItem('rasterAccessToken')
  const charts: chart[] = []
  const sources: RasterSource[] = []
  const geojsonSources: GeoJSONSourceRaw[] = []
  const geojsonLayers: LayerProps[] = []
  const layers: LayerProps[] = []
  const outlineLayers: string[] = []

  const configureOutlineLayer = function (
    id: string,
    coords: string,
    name: string,
    color: string
  ) {
    if (color === null || color === 'TBC') return

    const layerId = id + '-layer'

    geojsonSources.push({
      type: 'geojson',
      data: {
        type: 'Feature',
        properties: {
          description: name
        },
        geometry: {
          type: 'Polygon',
          coordinates: JSON.parse(coords)
        }
      }
    })
    try {
      const layer = {
        id: layerId,
        type: 'line' as const,
        // source: id + '-source',
        layout: {
          visibility: layerVisibility ? ('visible' as const) : ('none' as const)
        },
        paint: {
          'line-color': color,
          'line-width': 2
        },
        minzoom: 0,
        maxzoom: 5
      }
      geojsonLayers.push(layer)
      outlineLayers.push(layerId)
    } catch (e) {
      console.log(e)
    }
  }

  chartSets.forEach(function (chartSet) {
    configureOutlineLayer(
      chartSet.Identifier,
      chartSet.Coordinates,
      chartSet.Name,
      chartSet.OutlineColor
    )
    const files = chartSet.files

    const chart = {
      name: chartSet.productName,
      parts: [] as parts[]
    }

    files.forEach(function (file) {
      const fileId = file.id
      const fileName = file.name

      const config = {
        type: 'raster' as const,
        tiles: [chartSetImageBaseUrl + fileId + '/{z}/{x}/{y}.png?'],
        tileSize: 256,
        attribution: '&copy; Imray',
        minzoom: 5,
        maxzoom: 17
      }

      sources.push({
        id: fileId,
        ...config
      })

      const layerConfig = configureLayer(fileId, config)

      layers.push({
        ...layerConfig,
        layout: {
          visibility: layerVisibility ? ('visible' as const) : ('none' as const)
        },
        beforeId: 'social'
      })

      chart.parts.push({
        id: fileId,
        name: fileName,
        layerConfig: layerConfig
      })
    })

    charts.push(chart)
  })

  return {
    sources,
    layers,
    charts,
    geojsonSources,
    geojsonLayers,
    layerVisibility,
    setLayerVisibility
  }
}
